module.exports = __webpack_public_path__ + "img/rabesh.e3820216.svg";